// extracted by mini-css-extract-plugin
module.exports = {"container":"Testimonials-module--container--1TUT6","indicators":"Testimonials-module--indicators--21_1L","card":"Testimonials-module--card--156wD"};